export const userStatusTranslation = {
  enabled: 'Ativo',
  disabled: 'Inativo',
  pending: 'Pendente',
  default: ''
};
